import { render } from "./RelationshipTypeList.vue?vue&type=template&id=77ab33f1&scoped=true"
import script from "./RelationshipTypeList.vue?vue&type=script&lang=js"
export * from "./RelationshipTypeList.vue?vue&type=script&lang=js"

import "./RelationshipTypeList.vue?vue&type=style&index=0&id=77ab33f1&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77ab33f1"]])

export default __exports__